import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const Services = () => {
  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">Services</h1>
                <p className="colorWht">GreenOrange Services</p>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                <h2>
                  <span className="heading-bg"></span>Our Services<span className="heading-bg"></span>
                </h2>
                <p className="color4">GreenOrange a one stop for all your Solutions</p>
              </div>
            </div>
            <div className="row services text-center">
              <div className="col-lg-4 col-md-4 col-sm-4 padLR15">
                <article>
                  <Link to="/applications" title="Applications">
                    <div className="services-icons">
                      <span>
                        <i className="fa fa-map-marker"></i>
                      </span>
                    </div>
                    <div className="clearfix"></div>
                    <h3>Applications</h3>
                    <p>
                      As organizations are evolving into Digital Businesses, their application estate
                      is set to take a giant leap. The 20th century was about building robust...
                    </p>
                  </Link>
                  <p>
                    <Link className="btn btn-default morebtn" to="/applications" role="button">
                      See More
                    </Link>
                  </p>
                </article>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4 padLR15">
                <article>
                  <Link to="/enterprise-resource-planning" title="ERP - Enterprise Resource Planning">
                    <div className="services-icons">
                      <span>
                        <i className="fa fa-map-marker"></i>
                      </span>
                    </div>
                    <div className="clearfix"></div>
                    <h3>ERP</h3>
                    <p>
                      GreenOrange host the transportation management system (TMS), and integrates
                      with most legacy, Enterprise Resource Planning (ERP) applications...
                    </p>
                  </Link>
                  <p>
                    <Link className="btn btn-default morebtn" to="/enterprise-resource-planning" role="button">
                      See More
                    </Link>
                  </p>
                </article>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4 padLR15">
                <article>
                  <Link to="/consulting" title="Consulting">
                    <div className="services-icons">
                      <span>
                        <i className="fa fa-map-marker"></i>
                      </span>
                    </div>
                    <div className="clearfix"></div>
                    <h3>Consulting</h3>
                    <p>
                      Operating environment for global organizations is increasingly getting complex.
                      While IT is no longer a support function in an organization...
                    </p>
                  </Link>
                  <p>
                    <Link className="btn btn-default morebtn" to="/consulting" role="button">
                      See More
                    </Link>
                  </p>
                </article>
              </div>
            </div>
            <div className="row services text-center padB30">
              <div className="col-lg-4 col-md-4 col-sm-4 padLR15">
                <article>
                  <Link title="Mobility" to="/mobility">
                    <div className="services-icons">
                      <span>
                        <i className="fa fa-map-marker"></i>
                      </span>
                    </div>
                    <h3>Mobility</h3>
                    <p>
                      Collaboration, connectivity and communication are the need of the hour for
                      organizations. It is a constant endeavor to improve...
                    </p>
                  </Link>
                  <p>
                    <Link className="btn btn-default morebtn" to="/mobility" role="button">
                      See More
                    </Link>
                  </p>
                </article>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4 padLR15">
                <article>
                  <Link title="Business Process" to="/business-process">
                    <div className="services-icons">
                      <span>
                        <i className="fa fa-map-marker"></i>
                      </span>
                    </div>
                    <h3>Business Process</h3>
                    <p>
                      Today, the world markets have matured to be highly industry, process and
                      segment specific, and there has been a major shift from the initial days of...
                    </p>
                  </Link>
                  <p>
                    <Link className="btn btn-default morebtn" to="/business-process" role="button">
                      See More
                    </Link>
                  </p>
                </article>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4 padLR15">
                <article>
                  <Link title="GPS Tracking" to="/gps-tracking-service">
                    <div className="services-icons">
                      <span>
                        <i className="fa fa-map-marker"></i>
                      </span>
                    </div>
                    <h3>GPS Tracking</h3>
                    <p>
                      Not long ago it seemed that everything is already discovered in GSM network,
                      but HSCSD, GPRS, EDGE bearers created new possibilities for remote...
                    </p>
                  </Link>
                  <p>
                    <Link className="btn btn-default morebtn" to="/gps-tracking-service" role="button">
                      See More
                    </Link>
                  </p>
                </article>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default Services;

